export const STATUS = {
  Draft: 'Draft',
  Created: 'Created',
  PendingOnVendor: 'PendingOnVendor',
  AcceptedByVendor: 'AcceptedByVendor',
  RejectedByVendor: 'RejectedByVendor',
  PendingOnCustomer: 'PendingOnCustomer',
  AcceptedByCustomer: 'AcceptedByCustomer',
  RejectedByCustomer: 'RejectedByCustomer',
  Cancel: 'Cancel',
  Closed: 'Closed',
  AcceptedByUser: 'AcceptedByUser',
  RejectedByUser: 'RejectedByUser',
  PendingOnUser: 'PendingOnUser',
  Expire: 'Expire',
};
